import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchInputDynamicComponent } from '@components/search-input-dynamic/search-input-dynamic.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ProjectsService } from '@services/projects/projects.service';
import { NotificationsService, ObservatoryService, StorageService } from '@services/services.module';
import { Subject, Subscription, timer } from 'rxjs';
import { Employee } from '@pages/admin/empleados/employee.model';
import { APP_URLS } from '@app/constants/app-urls';
import { UtilsService } from '@app/services/utils/utils.service';

@Component({
  selector: 'app-proyectos',
  templateUrl: './proyectos.component.html',
  styleUrls: ['./proyectos.component.scss']
})
export class ProyectosComponent implements OnInit {
  @ViewChild('searchInput') searchInput: SearchInputDynamicComponent;
  @ViewChild('inputFlatRateAllEmployees') inputFlatRateAllEmployees: ElementRef;
  @ViewChild('inputDateEndPickerAllEmployees') inputDateEndPickerAllEmployees: ElementRef;
  @ViewChild('searchInputProjects') searchInputProjects: SearchInputDynamicComponent;

  private subscriptions: Array<Subscription> = [];
  private anyActivityTypeSelected = false;
  private activityTypeFromProject = [];
  private employeesAsociatedProjectCopy = [];
  private employeesInitialFlatRateCopy = [];
  private employeesToDisssociate = [];
  private endDateStorage: Date;
  private employeesToModify = [];
  public APP_URLS = APP_URLS;
  public blockAll = false;
  public modelProject: any; // Model Project
  public userData: any;
  public clearListEmployee: Subject<void> = new Subject<void>();
  public clearListProject: Subject<void> = new Subject<void>();
  public clearListClient: Subject<void> = new Subject<void>();
  public textButton = '';
  public activeFilterRatePositive = false;
  public offices = [];
  public divisions = [];
  public projectClassProject = [];
  public manPowerValidation = false;
  public typeProject = [];
  public clientAll = [];
  public activityTypeALl = [];
  public employeesAsociatedProject: Employee[] = [];
  public employeesAsociatedProjectHistoric: Employee [] = [];
  public showValidatorError: boolean;
  public projectNameValidator: boolean;
  public sapIdValidator: boolean;
  public manpowerIdValidator: boolean;
  public availableButton = true;
  public projectDisabledElements: any = {
    varProSapId: false,
    varProManpowerId: false,
    startDate: false,
    endDate: false
  };
  public employeesToAssociate = [{
    // dateEndProEmp: null,
    initDateProject: '',
    endDate: '',
    initDateProEmp: '',
    initDate: '',
    endDateProEmp: '',
    employeeId: '', // number
    intProId: '', // number
    nameEmployee: '',
    rateProject: '',
    surnamesEmployee: '',
    id: 1
  }];
  public employee: any = {
    Id: '',
    name: ''
  };
  public project: any = {
    Id: '',
    name: ''
  };

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private observatory: ObservatoryService,
    private modalService: NgbModal,
    private projectsService: ProjectsService,
    private formBuilder: FormBuilder,
    private storage: StorageService,
    private notification: NotificationsService,
    public translate: TranslateService,
    private router: Router,
    public utilsService: UtilsService
  ) {
    window.scrollTo(0, 0);
    this.textButton = 'GEST_PROYECTOS.CREATE_PROJECT';
    this.initModel();
    this.getAllData();
  }

  initModel() {
    this.modelProject = this.formBuilder.group({
      booProActivo: [1], // number
      endDateProject: [''], // string
      initDateProject: [''], // string
      intClapro: [''],
      intCliId: ['', [Validators.required]],
      intDivId: ['', [Validators.required]],
      intOfiId: ['', [Validators.required]],
      intProId: [''],
      intTipactId: [[]],
      intTipproId: ['', [Validators.required]], // number
      varProManpowerId: ['', [Validators.required]],
      varProSapId: ['', [Validators.required]], // string
      varProDescripcion: ['', [Validators.required]], // string
      startDate: [''], // date
      endDate: [''], // date
      dateEndPickerAllEmployee: [''],
      flatRateAllEmployees: [''], // number
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.translate.get(this.activatedRoute.snapshot.data['title'])
      .subscribe((res: string) => { this.titleService.setTitle(res); }
    );
    this.userData = this.storage.get('userDataStorage');
    this.observatory.setData('idItemList', '');
    this.storage.set('lastEmployeeToAssociate', []);
  }

  validateCodeText($event) {
    this.showValidatorError = $event;
    this.availableButton = $event;
  }

  validateProjectName($event) {
    this.projectNameValidator = $event;
    this.availableButton = $event;
  }

  validateSapId($event) {
    this.sapIdValidator = $event;
    this.availableButton = $event;
  }

  validateManpowerId($event) {
    this.manpowerIdValidator = $event;
    this.availableButton = $event;
  }

  getAllData(): void {
    this.subscriptions.push(
      this.projectsService.getTypeProject().subscribe(projectTypeData => {
        if (Array.isArray(projectTypeData)) {
          this.typeProject = projectTypeData;
        }
      }),
      this.projectsService.getAllClients().subscribe(allClientData => {
        if (Array.isArray(allClientData)) {
          this.clientAll = allClientData;
        }
      }),
      this.projectsService.getAllActivityType().subscribe(allActivityType => {
        if (Array.isArray(allActivityType)) {
          this.activityTypeALl = allActivityType;
          this.activityTypeALl.map(item => {
            item.checked = false;
            return item;
          });
        }
      }),
      this.projectsService.getOffices().subscribe((data: any[]) => {
        if (Array.isArray(data)) {
          this.offices = data;
        }
      }),
      this.projectsService.getDivisions().subscribe((data: any[]) => {
        if (Array.isArray(data)) {
          this.divisions = data;
        }
      }),
      this.projectsService.getClassificacionProjects().subscribe((data: any[]) => {
        if (Array.isArray(data)) {
          this.projectClassProject = data;
        }
      }),
    );
  }

  routeTo(route): void {
    this.router.navigate([route]);
  }

  openModal(content): void {
    this.modalService.open(content);
  }

  getEmployee(employee, itemListAssociate): void {
    if (employee.Id) {
      if (this.employeesAsociatedProject.find(m => m.employeeId === employee.Id)) {
        this.notification.setWarning(this.translate.instant('GEST_PROYECTOS.EMPLOYEE_FOUND'));
        this.employee = {
          Id: '',
          name: ''
        };
      } else {
        const findEmp = this.employeesToAssociate.find(m => m.employeeId === employee.Id);
        // If user try to add and employee already in associate new employee to project
        if (findEmp) {
          this.notification.setWarning(this.translate.instant('GEST_PROYECTOS.PROJECT_EMPLOYEE_ALREADY_IN_ASSOCIATE_LIST1') + ' ' + findEmp.nameEmployee.toUpperCase() +
            ' ' + this.translate.instant('GEST_PROYECTOS.PROJECT_EMPLOYEE_ALREADY_IN_ASSOCIATE_LIST2'));
          itemListAssociate.employeeId = '';
        } else {
          itemListAssociate.employeeId = employee.Id;
          this.employee = employee;
        }
      }
    } else {
      this.employee = {
        Id: '',
        name: ''
      };
    }
  }

  getProject(project): void {
    this.endDateStorage = null;
    // Clear employee lists
    this.clearOutListAssociateEmployee();
    this.clearOutFieldsAssociateNewEmployee();
    // Clear employee to associate
    this.clearEmployee();
    if (project) {
      this.project.Id = project;
      // const projectSelected = this.storage.get('listAllprojects').find(m => m.intProId === this.project.Id);
      this.modelProject.value.intProId = project;
      this.textButton = 'GEST_PROYECTOS.MODIFY_PROJECT';
      this.subscriptions.push(
        this.projectsService.getDataProject(project).subscribe((projectData) => {
          if (projectData) {
            if (projectData[0].endDateProject) {
              this.blockAll = true;
            }
            this.activityTypeFromProject = projectData;
            this.activityTypeFromProject.forEach(item => {
              item.activityTypeId.find(element => {
                if (this.activityTypeALl.find(m => m.activityTypeId === element)) {
                  this.activityTypeALl.find(m => m.activityTypeId === element).checked = true;
                  this.anyActivityTypeSelected = true;
                } else {
                  this.activityTypeALl.find(m => m.activityTypeId === element).checked = false;
                  this.anyActivityTypeSelected = false;
                }
              });
            });
            projectData.map(item => {
              if (!!item.initDateProject) {
                const year = item.initDateProject.replace(/-/g, '').substring(0, 4);
                const month = item.initDateProject.replace(/-/g, '').substring(4, 6);
                const day = item.initDateProject.replace(/-/g, '').substring(6, 8);
                item.startDate = new Date(Number(year), Number(month) - 1, Number(day));
              } else {
                item.initDateProject = '';
                item.startDate = '';
              }
              if (!!item.endDateProject) {
                const year = item.endDateProject.replace(/-/g, '').substring(0, 4);
                const month = item.endDateProject.replace(/-/g, '').substring(4, 6);
                const day = item.endDateProject.replace(/-/g, '').substring(6, 8);
                item.endDate = new Date(Number(year), Number(month) - 1, Number(day));
                this.endDateStorage = new Date(Number(year), Number(month) - 1, Number(day));
              } else {
                item.endDateProject = '';
                item.endDate = null;
              }
              return item;
            });

            this.modelProject.setValue(
              {
                booProActivo: 1,
                endDateProject: projectData[0].endDateProject ? projectData[0].endDateProject : '',
                initDateProject: projectData[0].initDateProject ? projectData[0].initDateProject : '',
                intClapro: projectData[0].intClapro ? projectData[0].intClapro : '',
                intCliId: projectData[0].intCliId ? projectData[0].intCliId : '',
                intDivId: projectData[0].intDivId ? projectData[0].intDivId : '',
                intOfiId: projectData[0].intOfiId ? projectData[0].intOfiId : '',
                intProId: projectData[0].intProId ? projectData[0].intProId : project,
                intTipactId: projectData[0].activityTypeId ? projectData[0].activityTypeId : [],
                intTipproId: projectData[0].intTipproId ? projectData[0].intTipproId : '',
                varProManpowerId: projectData[0].varProManpowerId ? projectData[0].varProManpowerId : '',
                varProSapId: projectData[0].varProSapId ? projectData[0].varProSapId : '',
                varProDescripcion: projectData[0].varProDescripcion ? projectData[0].varProDescripcion : '',
                startDate: projectData[0].startDate ? projectData[0].startDate : '',
                endDate: projectData[0].endDate ? projectData[0].endDate : '',
                dateEndPickerAllEmployee: projectData[0].dateEndPickerAllEmployee ? projectData[0].dateEndPickerAllEmployee : '',
                flatRateAllEmployees: projectData[0].flatRateAllEmployees ? projectData[0].flatRateAllEmployees : '',
              }
            );
            this.bloqFields();
          }
        }),
        this.projectsService.getEmployeeAsociatedProject(project).subscribe((employeeAsociatedProject) => {
          const projectValue = this.modelProject.value;
          if (employeeAsociatedProject) { // .slice(0, 3)
            this.employeesAsociatedProject = employeeAsociatedProject
              .filter(m => m.initDateProEmp !== '' && m.endDateProEmp === '')
              .map(item => {
                item.startDate = item.initDateProEmp.replace(/-/g, '');
                item.initDateProject = projectValue.initDateProject.replace(/-/g, '');
                item.intProId = projectValue.intProId;
                item.endDate = item.endDateProEmp.replace(/-/g, '');
                if (!this.hasRateProject(item)) {
                  item.rateProject = 0;
                }
                return item;
              }
            );

            this.employeesAsociatedProjectCopy = JSON.parse(JSON.stringify(this.employeesAsociatedProject));
            this.employeesInitialFlatRateCopy =  JSON.parse(JSON.stringify(this.employeesAsociatedProject));
            this.orderAndFilterListEmployees();

            this.employeesAsociatedProjectHistoric = employeeAsociatedProject
              .filter(m => m.endDateProEmp)
              .map((item) => {
                if (!this.hasRateProject(item)) {
                  item.rateProject = 0;
                }
                return item;
              })
              .sort(this.utilsService.compareEmployeeByName);
          }
        }),
      );
    }
  }

  setClient(client): void {
    const clientId = client ? client : '';
    this.modelProject.controls.intCliId.setValue(clientId);
  }
  setStartDate($event): void {
    this.modelProject.controls.startDate.setValue($event);
  }
  setEndDate($event): void {
    this.modelProject.controls.endDate.setValue($event);
  }

  /**
   * Function to set end date and change text button
   */
  setEndDateProject($event): void {
    this.setEndDate($event);
    if (this.modelProject.value.endDate && !this.blockAll) {
      this.textButton = 'GEST_PROYECTOS.PROJECT_END_DATE';
    }
  }

  bloqFields(): void {
    this.projectDisabledElements.varProSapId = !this.projectDisabledElements.varProSapId;
    this.projectDisabledElements.varProManpowerId = !this.projectDisabledElements.varProManpowerId;
    if (this.modelProject.value.startDate) {
      this.projectDisabledElements.startDate = true;
    } else {
      this.projectDisabledElements.startDate = false;
    }
    if (this.modelProject.value.endDateProject) {
      this.projectDisabledElements.endDate = true;
    } else {
      this.projectDisabledElements.endDate = false;
    }
  }

  /**
   * Function to save the project
   * @param modelProject: Form model with project information
   */
  saveProject(modelProject: NgForm): void {
    window.scrollTo(0, 0);
    if (this.employee && this.employee.Id !== '') {
      this.employee = {
        Id: '',
        name: ''
      };
    }

    if (this.compareDatesAndNotify(this.modelProject.value.startDate, this.modelProject.value.endDate)) {
      const dates = [
        { dateOne: this.modelProject.value.startDate },
        { dateTwo: this.modelProject.value.endDate }
      ];
      // Format parameters date
      this.formatParametersDate(dates).then((val: any) => {
        this.modelProject.value.booProActivo = 1;
        if (val.dateOne) {
          this.modelProject.value.initDateProject = val.dateOne;
        } else {
          this.modelProject.value.startDate = '';
          this.modelProject.value.initDateProject = '';
        }
        if (val.dateTwo) {
          this.modelProject.value.endDateProject = val.dateTwo;
        } else {
          this.modelProject.value.endDate = null;
          this.modelProject.value.endDateProject = null;
        }
        this.subscriptions.push(
          this.projectsService.addProject(this.modelProject.value).subscribe(data => {
            if (data) {
              let sendEmployee: any = {
                employeesToAssociate: [],
                projectId: ''
              };

              this.updateAndLoadAllProjects().then(() => {
                if (data.projectId) {
                  this.project.Id = data.projectId;
                  sendEmployee.projectId = data.projectId;
                  this.notification.setSuccess(
                    this.translate.instant('GEST_PROYECTOS.PROJECT')
                    + this.modelProject.value.varProDescripcion.toUpperCase()
                    + this.translate.instant('GEST_PROYECTOS.PROJECT_CREATE_OK')
                  );
                  sendEmployee = this.saveFormatNewAsociateEmployees();
                  this.textButton = 'GEST_PROYECTOS.MODIFY_PROJECT';
                  const value = this.modelProject.value.varProSapId + ' ' + this.modelProject.value.varProDescripcion;
                  this.searchInput.value = value;

                  // If there are new employees to asociate
                  if (!!sendEmployee.employeesToAssociate.length) {
                    this.caseNewEmployeesModifyExistProject(sendEmployee, true);
                  }
                  // If there are any new employee to disassociate to project
                  if (!!this.employeesToDisssociate.length || this.modelProject.value.dateEndPickerAllEmployee) {
                    this.caseDissociateEmployees();
                  }
                  this.getProject(data.projectId);
                }

                // If a project is modified CORRECTLY
                if (data.response === 'OK') {
                  sendEmployee.projectId = this.project.Id;
                  this.notification.setSuccess(this.translate.instant('GEST_PROYECTOS.PROJECT_OK_MODIFY'));
                  sendEmployee = this.saveFormatNewAsociateEmployees();
                  this.textButton = 'GEST_PROYECTOS.MODIFY_PROJECT';
                  // If there are new employees to asociate
                  if (!!sendEmployee.employeesToAssociate.length) {
                    this.caseNewEmployeesModifyExistProject(sendEmployee, false);
                  }
                  // If there are any new employee to disassociate to project
                  if (!!this.employeesToDisssociate.length || this.modelProject.value.dateEndPickerAllEmployee) {
                    this.caseDissociateEmployees();
                  }
                  this.getProject(this.project.Id);
                }

                // Error cases
                if (data.response !== 'OK' && !data.projectId) {
                  this.notification.setWarning(this.translate.instant('ERRORS.' + data.response));
                }
              });
            }
          })
        );
      }); // .Format parameters date
    }
    if (this.employeesToModify.length > 0) {
      const sendEmployee = {
        employeesToAssociate: this.employeesToModify,
        projectId: this.project.Id
      };
      this.insertAsociateEmployees(sendEmployee).then(() => {
        this.getProject(this.project.Id);
      });
    }
  }

  updateAndLoadAllProjects(): Promise<void> {
    return new Promise((resolve) => {
      this.subscriptions.push(
        this.projectsService.getAllProjects().subscribe(listProyecData => {
          if (listProyecData) {
            let listAllProject: any = [];
            listAllProject = listProyecData;
            this.storage.remove('listAllprojects');
            listAllProject.sort(function (a, b) {
              if (a.varProDescripcion < b.varProSapId) { return -1; }
              if (a.varProDescripcion > b.varProSapId) { return 1; }
              return 0;
            });
            listAllProject.map(function (item) {
              item.campoCompleto = item.varProSapId + ' ' + item.varProDescripcion;
              item.Id = item.intProId;
              return item;
            });
            this.storage.set('listAllprojects', listAllProject);
            this.observatory.setData('updateList', null);
            // Force delete last searched element
            this.observatory.setData('idItemList', null);
            resolve(listAllProject);
            // Reload project list searchInput
            this.searchInputProjects.getList();
          }
        }),
        this.projectsService.getProjects(this.userData.employeeNumber).subscribe((proyectData) => {
          if (proyectData) {
            if (!this.storage.get('listProjectsByEmployee')) {
              this.storage.remove('listProjectsByEmployee');
              proyectData.sort((a, b) => {
                if (a.description < b.description) { return -1; }
                if (a.description > b.description) { return 1; }
                return 0;
              });
              proyectData.map((item) => {
                item.campoCompleto = item.sapId + ' ' + item.description;
                item.Id = item.projectId;
                return item;
              });
              this.observatory.setData('updateList', null);
              this.observatory.setData('proyectos', proyectData);
              this.storage.set('listProjectsByEmployee', proyectData);
              this.storage.set('allProjects', true);
            }
          }
        })
      );
    });
  }

  caseNewEmployeesModifyExistProject(sendEmployee, newProject) {
    if (newProject) {
      const projectSelected = this.storage.get('listAllprojects').find(m => m.intProId === this.project.Id);
      sendEmployee.projectId = this.project.Id;
      sendEmployee.employeesToAssociate.map(item => {
        item.intProId = this.project.Id;
        item.initDateProject = projectSelected.initDateProject.replace(/-/g, '');
        return item;
      });
      this.runInsertAsociateEmployee(sendEmployee);
    } else {
      this.runInsertAsociateEmployee(sendEmployee);
    }
  }

  runInsertAsociateEmployee(sendEmployee): void {
    this.insertAsociateEmployees(sendEmployee).then((val: any) => {
      if (val) {
        const source = timer(1500);
        source.subscribe(() => {
          this.notification.setSuccess(this.translate.instant('GEST_PROYECTOS.EMPLOYEE_ASOCIATE_OK'));
        });
        this.clearOutFieldsAssociateNewEmployee();
      }
    });
  }

  caseDissociateEmployees() {
    let sendEmployee: any = {
      employeesToAssociate: [],
      projectId: this.project.Id
    };

    const source = timer(1500);
    if (this.modelProject.value.dateEndPickerAllEmployee) {
      this.employeesAsociatedProject.map(item => {
        item.initDateProEmp = item.initDateProEmp.replace(/-/g, '');
        delete item.startDate;
        delete item.endDate;
        return item;
      });
      // Create objet to send to server with employee data
      sendEmployee = {
        employeesToAssociate: this.employeesAsociatedProject,
        projectId: this.project.Id
      };
      this.insertAsociateEmployees(sendEmployee).then((val: any) => {
        if (val.ret) {
          source.subscribe(() => {
            this.notification.setSuccess(this.translate.instant('GEST_PROYECTOS.DISASOCIATE_EMPLOYEE_OK'));
            // Reset input
            this.modelProject.value.dateEndPickerAllEmployee = '';
            // Reset employeesToDisssociate
            this.employeesAsociatedProject = [];
            this.clearListEmployeesAssociatedProject();
          });
        } else {
          this.notification.setWarning(this.translate.instant('ERRORS.' + val.message));
          // reset input
          this.modelProject.value.dateEndPickerAllEmployee = '';
        }
      });
    // Disasociate only items where endDateProEmp
    } else if (!!this.employeesToDisssociate.length) {
      sendEmployee = {
        employeesToAssociate: this.employeesToDisssociate,
        projectId: this.project.Id
      };
      this.insertAsociateEmployees(sendEmployee).then((val: any) => {
        if (val.ret) {
          source.subscribe(() => {
            this.notification.setSuccess(this.translate.instant('GEST_PROYECTOS.DISASOCIATE_EMPLOYEE_OK'));
          });
        } else {
          this.notification.setWarning(this.translate.instant('ERRORS.' + val.message));
        }
        // Reset employeesToDisssociate
        this.employeesToDisssociate = [];
      });
    }
    this.clearOutFieldsAssociateNewEmployee();
  }

  insertAsociateEmployees(employeesToAssociate: any) {
    return new Promise((resolve) => {
      if (employeesToAssociate && this.project && this.project.Id) {
        this.subscriptions.push(
          this.projectsService.postAsociateEmployeesToProject(employeesToAssociate).subscribe(dataReturn => {
            if (dataReturn) {
              if (dataReturn.response === 'OK') {
                this.employeesToModify = [];
                this.projectsService.getEmployeeAsociatedProject(this.project.Id)
                  .subscribe((employeeAsociatedProject) => {
                    const projectValue = this.modelProject.value;
                    if (employeeAsociatedProject) { // .slice(0, 3)
                      this.employeesAsociatedProject = employeeAsociatedProject
                        .filter(m => m.initDateProEmp !== '' && m.endDateProEmp === '')
                        .map(item => {
                          item.startDate = item.initDateProEmp.replace(/-/g, '');
                          item.initDateProject = projectValue.initDateProject.replace(/-/g, '');
                          item.intProId = projectValue.intProId;
                          item.endDate = item.endDateProEmp.replace(/-/g, '');
                          return item;
                        });
                      this.clearListEmployeesAssociatedProject();
                      this.orderAndFilterListEmployees();
                      this.employeesAsociatedProjectHistoric = employeeAsociatedProject
                        .filter(m => m.endDateProEmp)
                        .sort(this.utilsService.compareEmployeeByName);
                      this.clearOptionsAllEmployees();
                    }
                  }
                );
                const response = {
                  ret: true,
                  message: dataReturn.response
                };
                resolve(response);
              } else {
                this.notification.setWarning(this.translate.instant('ERRORS.' + dataReturn.response));
                const response = {
                  ret: false,
                  message: dataReturn.response
                };
                resolve(response);
              }
            } else {
              const response = {
                ret: false,
                message: 'EMPLOYEE_ASOCIATE_ERROR'
              };
              resolve(response);
            }
          }
          ));
      } else {
        const response = {
          ret: false,
          message: 'EMPLOYEE_ASOCIATE_ERROR'
        };
        resolve(response);
      }
    });
  }

  cancel(): void {
    this.searchInputProjects.value = '';
    this.searchInputProjects.externalSelected = '';
    this.searchInputProjects.enableInput = false;
    this.searchInput.value = '';
    this.searchInput.enableInput = false;
    this.storage.set('lastEmployeeToAssociate', []);
    this.textButton = 'GEST_PROYECTOS.CREATE_PROJECT';
    this.initModel();
    this.activityTypeALl.forEach((item: any) => item.checked = false);
    this.clearOutFieldsAssociateNewEmployee();
    this.clearOutListAssociateEmployee();
    this.clearFlatRateAllEmployees();
    this.clearEmployee();
    this.employeesToModify = [];
    this.anyActivityTypeSelected = false;
    this.blockAll = false;
    this.project = {
      Id: '',
      name: ''
    };
    this.employeesToAssociate = [{
      initDateProject: '',
      endDate: '',
      initDateProEmp: '',
      initDate: '',
      endDateProEmp: '',
      employeeId: '',
      intProId: '',
      nameEmployee: '',
      rateProject: '',
      surnamesEmployee: '',
      id: 1
    }];

    this.projectDisabledElements = {
      varProSapId: false,
      varProManpowerId: false,
      startDate: false,
      endDate: false
    };

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  addAsociateEmployee(item, index): void {
    item.employeeId = this.employee.Id;
    const employeeSelected = this.storage.get('listEmployee').find(m => m.Id === item.employeeId);
    const projectSelected = this.storage.get('listAllprojects').find(m => m.intProId === this.project.Id);
    const dates: any = [
      { dateOne: item.initDate },
      { dateTwo: item.endDate }
    ];
    this.formatParametersDate(dates).then((val: any) => {
      item.initDateProEmp =  val.dateOne ? val.dateOne.replace(/-/g, '') : '';
      item.endDateProEmp =  val.dateTwo ?  val.dateTwo.replace(/-/g, '') : null;
      item.nameEmployee = employeeSelected.nameEmployee;
      item.surnamesEmployee = employeeSelected.surnamesEmployee;
      if (projectSelected) {
        item.intProId = projectSelected.intProId;
        item.initDateProject = projectSelected.initDateProject.replace(/-/g, '');
      } else {
        item.intProId = '';
        item.initDateProject = '';
      }

      if (!this.hasRateProject(item)) {
        item.rateProject = 0;
      } else {
        item.rateProject = '' + item.rateProject;
        item.rateProject = item.rateProject.trim();
        item.rateProject = parseFloat(item.rateProject).toFixed(2);
      }

      const arrayEmployeeToAssociate = this.storage.get('lastEmployeeToAssociate');
      if (!arrayEmployeeToAssociate.includes(index)) {
        this.employeesToAssociate.push({
          initDateProject: '',
          endDate: '',
          initDateProEmp: '',
          initDate: '',
          endDateProEmp: '',
          employeeId: '',
          intProId: '',
          nameEmployee: '',
          rateProject: '',
          surnamesEmployee: '',
          id: this.employeesToAssociate.length + 1
        });
        arrayEmployeeToAssociate.push(index);
        this.storage.set('lastEmployeeToAssociate', arrayEmployeeToAssociate);
      }
    });
  }

  saveFormatNewAsociateEmployees(): any {
    const sendEmployee: any = {
      employeesToAssociate: [],
      projectId: 0
    };
    if (!!this.employeesToAssociate.length && this.employeesToAssociate.find(m => m.employeeId !== '')) {
      this.employeesToAssociate.filter(m => m.employeeId !== '').forEach((element: any) => {
        for (const key in element) {
          if (element[key] === (null || undefined)) {
            delete element[key];
          } else {
            if (key === 'intProId') {
              element[key] = this.project.Id;
            }
            element[key] = element[key];
          }
        }
        delete element.initDate;
        delete element.endDate;
        delete element.id;
        sendEmployee.employeesToAssociate.push(element);
      });

      sendEmployee.projectId = this.project.Id;
      return sendEmployee;
    } else {
      return sendEmployee;
    }
  }

  modifyDateEndOneAsociatedEmployee(employeeEndDate, employee): boolean {
    if (employeeEndDate) {
      const date: any = [
        { dateOne: employeeEndDate }
      ];
      this.formatParametersDate(date).then((val: any) => {
        this.employeesAsociatedProject
          .filter(item => item.employeeId === employee.employeeId)
          .map(item => {
            item.endDate = employeeEndDate;
            item.endDateProEmp = val.dateOne;
          });
        this.employeesToModify
          .filter(item => item.employeeId === employee.employeeId)
          .map(item => {
            item.endDate = employeeEndDate;
            item.endDateProEmp = val.dateOne;
          });
        return true;
      });
    } else {
      this.employeesAsociatedProject
        .filter(item => item.employeeId === employee.employeeId)
        .map(item => {
          item.endDate = null;
          item.endDateProEmp = null;
        });
      this.employeesToModify
        .filter(item => item.employeeId === employee.employeeId)
        .map(item => {
          item.endDate = null;
          item.endDateProEmp = null;
        });
    }
    return true;
  }

  selectActivityType(event, item): void {
    item.checked = event.checked;
    if (item.checked === true) {
      this.modelProject.value.intTipactId.push(item.activityTypeId);
    } else {
      this.modelProject.value.intTipactId.splice(this.modelProject.value.intTipactId.indexOf(item.activityTypeId), 1);
    }
    if (this.activityTypeALl.find(m => m.checked === true)) {
      this.anyActivityTypeSelected = true;
    } else {
      this.anyActivityTypeSelected = false;
    }
  }

  async disasociateAllEmployees(dateEnd: Date): Promise<void> {
    this.restoreEmployeesAndApplyModified();
    const date: any = [
      { dateOne: dateEnd }
    ];
    await this.formatParametersDate(date).then((val: any) => {
      this.employeesAsociatedProject.forEach(item => {
        item.endDate = dateEnd;
        item.endDateProEmp = val.dateOne;
      });
    });
    this.orderAndFilterListEmployees();
  }

  /**
   * Function to apply the specified flat rate (tarifa única)
   * to all associated employees
   */
  applyFlatRateAllEmployees(): void {
    this.restoreEmployeesAndApplyModified();
    const auxFlatRate = this.invalidFlatRate() ? 0 : this.modelProject.value.flatRateAllEmployees;
    this.employeesAsociatedProject.forEach(item => {
      item.rateProject = auxFlatRate;
      this.addRateProjectListModify(item);
    });
    this.orderAndFilterListEmployees();
  }

  /**
   * Function to apply filter by positive rate
   */
  applyFilterByRatePositive(): void {
    this.activeFilterRatePositive = !this.activeFilterRatePositive;
    this.orderAndFilterListEmployees();
  }

  /**
   * Function to apply filter by positive rate
   */
  applyFilterByEmployee(employee: any): void {
    if (employee && employee.Id) {
      this.employee = employee;
    } else {
      this.restoreEmployeesAndApplyModified();
      this.employee = {
        Id: '',
        name: ''
      };
    }

    this.orderAndFilterListEmployees();
  }

  /**
   * Function to order the list employees asociated project
   */
  orderAndFilterListEmployees(): void {
    if (this.employeesAsociatedProjectCopy.length === this.employeesAsociatedProject.length) {
      this.employeesAsociatedProjectCopy = JSON.parse(JSON.stringify(this.employeesAsociatedProject));
    }

    if (this.activeFilterRatePositive) {
      this.filterByRatePositive();
    }

    if (this.employeesAsociatedProjectCopy.length !== this.employeesAsociatedProject.length
      && !this.activeFilterRatePositive
      && !this.isSelectedEmployee()
    ) {
      this.restoreEmployeesAndApplyModified();
    }

    if (this.isSelectedEmployee()) {
      this.filterByEmployee();
    }

    this.orderListEmployeesAsociatedProjectByFlatRate();
  }

  /**
   * Function to order the list employees by rate
   * First positions for employees with a rate, then those who do not
   */
  orderListEmployeesAsociatedProjectByFlatRate(): void {
    let auxEmployeesListWithoutRate = [] as Employee[];
    let auxEmployeesListWithRate = [] as Employee[];

    this.employeesAsociatedProject.forEach(item => {
      item.rateProject > 0
        ? auxEmployeesListWithRate.push(item)
        : auxEmployeesListWithoutRate.push(item);
      this.addRateProjectListModify(item);
    });

    auxEmployeesListWithRate = auxEmployeesListWithRate.sort(this.utilsService.compareEmployeeByName);
    auxEmployeesListWithoutRate = auxEmployeesListWithoutRate.sort(this.utilsService.compareEmployeeByName);
    this.employeesAsociatedProject = auxEmployeesListWithRate.concat(auxEmployeesListWithoutRate);
  }

  filterByEmployee(): void {
    if (this.isSelectedEmployee()) {
      this.employeesAsociatedProject = this.employeesAsociatedProject
        .filter((item) => item.employeeId === this.employee.Id);
    }
  }

  /**
   * Function to filter by rate greater than zero
   */
  filterByRatePositive(): void {
    if (this.activeFilterRatePositive) {
      this.employeesAsociatedProject = this.employeesAsociatedProject
        .filter((item) => item.rateProject > 0);
    } else {
      this.employeesAsociatedProject = JSON.parse(JSON.stringify(this.employeesAsociatedProjectCopy));
    }
  }

  /**
   * Function to check if exist employee selected
   */
  isSelectedEmployee(): boolean {
    return this.employee && this.employee.Id !== '';
  }

  /**
   * Function to get the old rate employee
   * This old rate there is in associated employees list copy
   */
  getOldFlatRateEmployee(employee: Employee): Employee {
    const res = this.employeesInitialFlatRateCopy
      .find(item => item.employeeId === employee.employeeId);
    return res;
  }

  /**
   * Compare two string dates and open notification if exist error
   */
  compareDatesAndNotify(dStart: string, dEnd: string): boolean {
    let res = false;
    if ((!dEnd || !dStart || dStart <= dEnd) && String(dEnd) !== String(this.endDateStorage)) {
      res = true;
    } else if (String(dEnd) !== String(this.endDateStorage)) {
      this.notification.setWarning(this.translate.instant('FORM_EMPLEADO.ENDDATE_OVER_STARTDATE'));
    } else {
      this.notification.setWarning(this.translate.instant('FORM_EMPLEADO.ENDDATE_EQUALS_NEW_ENDDATE'));
    }
    return res;
  }

  /**
   * Function to compare two dates
   */
  compareDates(aDate: string, bDate: string): number {
    const aAuxDate = new Date(aDate);
    const bAuxDate = new Date(bDate);
    if (aAuxDate > bAuxDate) {
      return -1;
    } else if (aAuxDate < bAuxDate) {
      return 1;
    } else {
      return 0;
    }
  }

  formatParametersDate(dates) {
    return new Promise((resolve) => {
      let endMonth = '';
      let endDay = '';

      let initMonth = '';
      let initDay = '';

      let dateEnd;
      let dateInit;
      let dateThree;

      if (!!dates.length) {
        dates.forEach(element => {
          endMonth = '';
          endDay = '';
          initMonth = '';
          initDay = '';

          if (element.dateOne) {
            if (element.dateOne !== null && element.dateOne !== undefined) {
              if (element.dateOne.getDate() < 10) {
                initDay = '0' + element.dateOne.getDate();
              } else {
                initDay = '' + element.dateOne.getDate();
              }
              if (Number(element.dateOne.getMonth() + 1) < 10) {
                initMonth = '0' + Number(element.dateOne.getMonth() + 1);
              } else {
                initMonth = '' + Number(element.dateOne.getMonth() + 1);
              }
              dateInit = '' + element.dateOne.getFullYear() + initMonth + initDay;
            } else {
              dateInit = '';
            }
          } else if (element.dateTwo) {
            if (element.dateTwo !== null && element.dateTwo !== undefined) {
              if (element.dateTwo.getDate() < 10) {
                endDay = '0' + element.dateTwo.getDate();
              } else {
                endDay = '' + element.dateTwo.getDate();
              }
              if (Number(element.dateTwo.getMonth() + 1) < 10) {
                endMonth = '0' + Number(element.dateTwo.getMonth() + 1);
              } else {
                endMonth = '' + Number(element.dateTwo.getMonth() + 1);
              }
              dateEnd = '' + element.dateTwo.getFullYear() + endMonth + endDay;
            } else {
              dateEnd = '';
            }
          } else if (element.dateBirth) {
            if (element.dateBirth !== null && element.dateBirth !== undefined) {
              if (element.dateBirth.getDate() < 10) {
                initDay = '0' + element.dateBirth.getDate();
              } else {
                initDay = '' + element.dateBirth.getDate();
              }
              if (Number(element.dateBirth.getMonth() + 1) < 10) {
                initMonth = '0' + Number(element.dateBirth.getMonth() + 1);
              } else {
                initMonth = '' + Number(element.dateBirth.getMonth() + 1);
              }
              dateThree = '' + element.dateBirth.getFullYear() + initMonth + initDay;
            } else {
              dateThree = '';
            }
          }
        });
        const retorno = {
          'dateTwo': dateEnd,
          'dateOne': dateInit,
          'dateThree': dateThree
        };
        resolve(retorno);
      }
    });
  }

  validateManPower(data: string): void {
    this.manPowerValidation = !(data.match(/[a-zA-Z]/));
  }

  /**
   * Function to remove associated employee that was selected
   */
  clearEmployeeToAsociated(employeeAsociateFields): void {
    const index = this.employeesToAssociate.findIndex(m => m.id === employeeAsociateFields.id);
    if (index > -1) {
      this.employeesToAssociate.splice(index, 1);
      // Get last element (this element is the empty register)
      const lastItem = this.employeesToAssociate[this.employeesToAssociate.length - 1];
      // Update element id
      this.employeesToAssociate.find(m => m.id === lastItem.id).id = this.employeesToAssociate.length;
    }
  }

  /**
   * Function to clear the list of associated employees
   */
  clearListEmployeesAssociatedProject(): void {
    this.employeesAsociatedProjectCopy = [];
  }

  clearOutFieldsAssociateNewEmployee(): void {
    this.employeesToAssociate = [{
      initDateProject: '',
      endDate: '',
      initDateProEmp: '',
      initDate: '',
      endDateProEmp: '',
      employeeId: '',
      intProId: '',
      nameEmployee: '',
      rateProject: '',
      surnamesEmployee: '',
      id: 1
    }];
  }

  clearOutListAssociateEmployee(): void {
    this.employeesAsociatedProject = [];
    this.clearListEmployeesAssociatedProject();
    this.employeesAsociatedProjectHistoric = [];
    this.employeesToDisssociate = [];
  }

  clearEmployee(): void {
    this.employee = {
      Id: '',
      name: ''
    };
  }

  /**
   * Function to clear flat rate of all employees
   * Recovers the rates previous to the modification
   */
  clearFlatRateAllEmployees(): void {
    this.modelProject.value.flatRateAllEmployees = '';
    if (
        this.inputFlatRateAllEmployees &&
        this.inputFlatRateAllEmployees.nativeElement &&
        this.inputFlatRateAllEmployees.nativeElement.value
    ) {
      this.inputFlatRateAllEmployees.nativeElement.value = '';
    }

    this.employeesAsociatedProject.forEach(employee => {
      employee.rateProject = this.getOldFlatRateEmployee(employee).rateProject;
    });
    this.employeesToModify.forEach(item => {
      item.rateProject = this.getOldFlatRateEmployee(item).rateProject;
    });
    this.orderAndFilterListEmployees();
  }

  /**
   * Function to clear input of all employees options
   */
  clearOptionsAllEmployees(): void {
    if (this.modelProject.value.flatRateAllEmployees) {
      this.modelProject.value.flatRateAllEmployees = '';
      this.inputFlatRateAllEmployees.nativeElement.value = '';
    }
    if (this.modelProject.value.dateEndPickerAllEmployee) {
      this.modelProject.value.dateEndPickerAllEmployee = '';
      this.inputDateEndPickerAllEmployees.nativeElement.value = '';
    }
  }

  invalidFlatRate(): boolean {
    return this.modelProject.value.flatRateAllEmployees === '';
  }

  /**
   * Function to check if a employee as a rateProject nonzero
   */
  hasRateProject(employee: Employee): boolean {
    return employee.rateProject && employee.rateProject !== 0;
  }
  /**
   * Function to check if a employee as a endDatePropEmp
   */
  hasEndDateProject(employee: Employee): boolean {
    return employee.endDateProject && employee.endDateProject !== '';
  }
  /**
   * Function to check if a employee as a endDatePropEmp
   */
  hasEndDateProEmp(employee: Employee): boolean {
    return employee.endDateProEmp !== undefined && employee.endDateProEmp !== '';
  }
  /**
   * Function to check if a employee as a endDate
   */
  hasEndDate(employee: Employee): boolean {
    return employee.endDate !== undefined && String(employee.endDate) !== '' && employee.endDate !== null;
  }

  buttonSuccessValidation(): boolean {
    if (this.showValidatorError === undefined && this.modelProject.value.varProDescripcion.length > 0) {
      this.showValidatorError = true;
    }

    return !this.modelProject.value.startDate || !this.anyActivityTypeSelected || !this.showValidatorError || !this.availableButton;
  }

  reactivate(): void {
    if (this.project.Id !== '') {
      this.project.name = this.modelProject.value.varProSapId + ' ' + this.modelProject.value.varProDescripcion;
      const project = this.project;
      this.projectsService.putreactiveProject(this.project.Id).subscribe(res => {
        if (res) {
          this.notification.setSuccess(this.translate.instant('GEST_PROYECTOS.PROJECT_REACTIVATE'));
          this.cancel();
          this.searchInput.value = project.name;
          this.getProject(project.Id);
        }
      }, err => {
        this.notification.setWarning(this.translate.instant('ERRORS.' + err));
      });
    }
  }

  /**
   * Function to assign rate to employee
   * If is actived flat rate (tarifa única) it assigns to employee
   * Otherwise it assigns zero value
   */
  rateProjectChange(item: Employee): void {
    this.addRateProjectListModify(item);
    // Assign rate to employee in list employees asociated project
    const index = this.employeesAsociatedProject
      .findIndex((employee => employee.employeeId === item.employeeId));
    this.employeesAsociatedProject[index].rateProject
      = this.hasRateProject(item) ? item.rateProject : 0;
    this.orderAndFilterListEmployees();
  }

  /**
   * Function to add rate in employees to modify
   */
  addRateProjectListModify(item: Employee): void {
    const employees = this.employeesToModify
      .find(employee => employee.employeeId === item.employeeId);
    // Rate project to assign
    const rateToEmployee = this.hasRateProject(item) ? item.rateProject : 0;
    if (!employees) {
      const employeeToModify = {
        initDateProject: item.initDateProject,
        initDateProEmp: item.initDateProEmp.replace(/-/g, ''),
        employeeId: item.employeeId,
        intProId: item.intProId,
        nameEmployee: item.nameEmployee,
        rateProject: rateToEmployee,
        surnamesEmployee: item.surnamesEmployee
      };
      if (this.hasEndDate(item)) {
        employeeToModify['endDate'] = item.endDate;
      } else {
        delete(employeeToModify['endDate']);
      }
      if (this.hasEndDateProject(item)) {
        employeeToModify['endDateProject'] = item.endDateProject;
      } else {
        delete(employeeToModify['endDateProject']);
      }
      if (this.hasEndDateProEmp(item)) {
        employeeToModify['endDateProEmp'] = item.endDateProEmp;
      } else {
        delete(employeeToModify['endDateProEmp']);
      }
      this.employeesToModify.push(employeeToModify);
    } else {
      employees.rateProject = rateToEmployee;
      if (this.hasEndDate(item)) {
        employees.endDate = item.endDate;
      } else {
        delete(employees.endDate);
      }
      if (this.hasEndDateProject(item)) {
        employees['endDateProject'] = item.endDateProject;
      } else {
        delete(employees['endDateProject']);
      }
      if (this.hasEndDateProEmp(item)) {
        employees.endDateProEmp = item.endDateProEmp;
      } else {
        delete(employees.endDateProEmp);
      }
    }
  }

  /**
   * Function to restore employees after filters and apply modified employees
   */
  restoreEmployeesAndApplyModified(): void {
    if (this.employeesAsociatedProjectCopy.length >= this.employeesAsociatedProject.length) {
      this.employeesAsociatedProject = JSON.parse(JSON.stringify(this.employeesAsociatedProjectCopy));
    }

    this.employeesToModify.forEach((elem) => {
      const employee = this.employeesAsociatedProject
        .find((item) => item.employeeId === elem.employeeId);
      employee.rateProject = this.hasRateProject(elem) ? elem.rateProject : 0;
      if (this.hasEndDateProEmp(elem)) {
        employee.endDateProEmp = elem.endDateProEmp;
      } else {
        delete(employee.endDateProEmp);
      }
      if (this.hasEndDateProject(elem)) {
        employee['endDateProject'] = elem.endDateProject;
      } else {
        delete(employee['endDateProject']);
      }
      if (this.hasEndDate(elem)) {
        employee.endDate = elem.endDate;
      } else {
        delete(employee.endDate);
      }
    });
    this.employeesToModify = [];
  }
}
